import React from 'react'
import './portfolio.css'

const data = [
  {
    id: 1,
    image: 'https://cdn.dribbble.com/userupload/3864186/file/original-e76878961f17b4df6817b0d95a4a4d34.png?compress=1&resize=1024x768',
    title: 'NCDEV Ecosystem',
    github: 'https://github.com',
    live : 'https://www.ncdev.co/'
    
  },
  {
    id: 2,
    image: 'https://cdn.dribbble.com/userupload/3864186/file/original-e76878961f17b4df6817b0d95a4a4d34.png?compress=1&resize=1024x768',
    title: 'The Blog',
    github: 'https://github.com/PaballoStevens/blog.git',
    live : ''
    
  },
  {
    id: 3,
    image: 'https://cdn.dribbble.com/userupload/3864186/file/original-e76878961f17b4df6817b0d95a4a4d34.png?compress=1&resize=1024x768',
    title: 'Leave Management System',
    github: 'https://github.com/PaballoStevens/leave.git',
    live : ''
    
  },
  {
    id: 4,
    image: 'https://cdn.dribbble.com/userupload/3864186/file/original-e76878961f17b4df6817b0d95a4a4d34.png?compress=1&resize=1024x768',
    title: 'No code website builder',
    github: 'https://github.com/PaballoStevens/No_code_website_builder.git',
    live : ''
    
  },

  {
    id: 5,
    image: 'https://cdn.dribbble.com/userupload/3864186/file/original-e76878961f17b4df6817b0d95a4a4d34.png?compress=1&resize=1024x768',
    title: 'Checklist',
    github: 'https://github.com/PaballoStevens/checklist.git',
    live : ''
    
  },

  {
    id: 5,
    image: 'https://cdn.dribbble.com/userupload/3864186/file/original-e76878961f17b4df6817b0d95a4a4d34.png?compress=1&resize=1024x768',
    title: 'Saas-translator',
    github: 'https://github.com/PaballoStevens/saas-translator.git',
    live : ''
    
  },

]

function Portfolio() {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {
        data.map(({id, image, title, github, live}) => {
          return (
            <article key={id} className='portfolio__item'>
            <div className="portfolio__item-image">
              <img src={image} alt="" />
            </div>
            <h3>{title}</h3>
            <div className="portfolio__item-cta">
              <a href={github} className='btn' target='_blank'>Github</a>
              <a href={live} className='btn btn-primary' target='_blank'>Live</a>
            </div>
          </article>
          )
        })
      }
      </div>
    </section>
  )
}

export default Portfolio